<template>
  <d-card class="ubd-stats card-small h-100">
    <!-- Card Header -->
    <d-card-header v-if="title != null && title != undefined && title != ''" class="border-bottom">
      <div class="float-left">
        <h6 class="m-0">{{title}}</h6>
      </div>
      <div
        v-html="htmlSubtitle"
        v-if="htmlSubtitle != null && htmlSubtitle != undefined && htmlSubtitle != ''"
        class="float-right"
      ></div>
      <div class="dropdown m-0 float-right" v-if="hasReportListener">
       <button class="btn btn-outline-secondary dropdown-toggle-ellipsis" id="dropdownMenuButton"
         type="button" v-b-tooltip.hover.right title="Mais opções" 
         data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
         <i class="fas fa-ellipsis-v"></i>
       </button>
       <div class="dropdown-menu" id="dropTableOptions" aria-labelledby="dropdownMenuButton">
         <a class="dropdown-item" :class="loadingReport ? 'disabled loading-disabled' : ''" @click.stop="emitReport()">
          <template v-if="!loadingReport">
            <i class="fas fa-check mr-2"></i>
            Gerar relatório 
          </template>
          <b-spinner v-else small></b-spinner>
         </a>
       </div>
     </div>
    </d-card-header>
    <d-card-body class="d-flex flex-column">
      <!-- Chart -->
      <canvas width="100" ref="canvas" class="analytics-users-by-device mt-3 mb-4" />
      <!-- Legend  -->
      <div v-if="type == 'pie'" class="ubd-stats__legend w-10 m-auto pb-4">
        <div v-for="(label, idx) in computedLabels" :key="idx" class="ubd-stats__item">
          <div v-if="label.icon" v-html="label.icon" :style="{ color: label.iconColor }" />
          <span class="ubd-stats__stats">{{ label.title }}</span>
          <span class="ubd-stats__stats">{{ label.value | percentage }}</span>
        </div>
      </div>
    </d-card-body>
  </d-card>
</template>

<script>
import colors from "../../utils/colors";
import Chart from "../../utils/chart";
import _ from 'lodash';
export default {
  name: "chart-card",
  props: {
    chartConfig: {
      type: Object,
      default() {
        return {};
      }
    },
    chartOptions: {
      type: Object,
      default() {
        return {};
      }
    },
    chartData: {
      type: Object
    },
    title: {
      type: String,
      default: ""
    },
    htmlSubtitle: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "pie"
    },
    loadingReport: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasReportListener() {
      return this.$listeners && this.$listeners.report;
    },

    computedLabels() {
      this.chartData.hoverBorderColor = colors.white.toRGBA(1);

      if (!this.chartData || typeof this.chartData.labels === "undefined") {
        return [];
      }

      const parsedChartData = this.chartData.labels.map((label, idx) => {
        const dataset = this.chartData.datasets[0];

        return {
          title: label,
          icon: dataset.icons[idx],
          iconColor: dataset.backgroundColor[idx],
          value: dataset.data[idx]
        };
      });

      return parsedChartData;
    }
  },
  mounted() {
    let chartConfig;
    if (this.type == "pie") {
      const pieOptions = {
        legend: false,
        cutoutPercentage: 50,
        tooltips: {
          mode: "index",
          position: "nearest",
          enabled: false
        }
      };
      chartConfig = {
        type: "pie",
        data: this.chartData,
        options: _.merge(pieOptions, this.chartOptions)
      };
    } else if (this.type == "line") {
      const lineOptions = {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: value => this.$options.filters.number(value)
              }
            }
          ],
          xAxes: [
            {
              type: "category",
              labels: this.chartData.labels
            }
          ]
        },
        tooltips: {
          mode: "index",
          position: "nearest",
          enabled: false
        }
      };
      chartConfig = {
        type: "line",
        data: {
          datasets: this.chartData.datasets
        },
        options: _.merge(lineOptions, this.chartOptions),
      };
    }
    new Chart(this.$refs.canvas, chartConfig);
  },
  methods: {
    emitReport(){
      if(!this.loadingReport){
        this.$emit('report');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ div[class^="sc-tooltip-"] {
  z-index: 1;
}
.loading-disabled {
  background: gainsboro;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/common/chart-card.vue